import { Link } from "react-router-dom";
import { clsx } from "clsx";
import "./TabLink.scss";

interface ITabLinkProps {
  tab: {
    to: string;
    label: string;
    onClick: () => void;
    icon: React.ReactNode;
  };
  isActive: boolean;
}

export const TabLink: React.FC<ITabLinkProps> = ({ tab, isActive }) => {
  return (
    <Link
      key={tab.to}
      to={tab.to}
      onClick={tab.onClick}
      className={clsx(
        "TabLink",
        `TabLink_${`is${tab.label}`}`,
        isActive && "TabLink_isActive",
      )}
      aria-label={tab.label}
    >
      <div>{tab.icon}</div>
      <span>{tab.label}</span>
    </Link>
  );
};
